import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router} from "react-router-dom";
import ScrollToTop from "./components/scroll/ScrollToTop";

ReactDOM.render(
  <React.Suspense fallback={<h2>مشکلی پیش آمده !!</h2>}>
    <Router>
      <ScrollToTop>
          <App />
      </ScrollToTop>
    </Router>
  </React.Suspense>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
